import { Modal, Col, Row, Form } from 'react-bootstrap';
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import { FormInput } from '../../../components/formElements/FormInput';
import CommonService from '../../../services/CommonService';
import swal from 'sweetalert';
import CurrencyInput from '../../formElements/CurrencyInput'
import BaseService from '../../../services/BaseService';

const EditAdtrExpenditure = (props) => {
    const user = useContext(UserContext);
    const { onModalClose, adtrExpenditureInfo } = props;
    const [formErrors, setFormErrors] = useState({});
    const [adtrExpenditure, setAdtrExpenditure] = useState({ ...adtrExpenditureInfo });

    const handleChange = e => {
        const { name } = e.target;
        let value = e.target.value;

        setAdtrExpenditure(prevState => ({
            ...prevState, [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-adtr-expenditure');
        let formErrors = validateFormFields(form.elements);
        if (Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {
            setFormErrors({});
            var obj = {
                msgId: null,
                sysId: null,
                opr: "updateAdtrProceedExpenditure",
                hdrStruct: null,
                queryParam: null,
                reqData: {
                    "adtrProceedExpenditure": {
                        "adtrProceedExpenditureId": adtrExpenditure.adtrProceedExpenditureId,
                        "adtrProceedId": adtrExpenditure.adtrProceedId,
                        "purposeDesc": adtrExpenditure.purposeDesc,
                        "spentAmt": adtrExpenditure.spentAmt,
                        "LastUpdateUser": CommonService.getUserName(user)
                    }
                },

            };

            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0) {
                        toast.error(result.data.errors[0].message)
                    }
                    else {
                        toast.success("ADTR Proceed Expenditure updated successfully!");
                        onModalClose();
                    }

                });
        }
    }

    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit ADTR Proceed Expenditure</h3></Modal.Header>
            <Modal.Body>
                <form id="edit-adtr-expenditure">
                    <div className="contactForm">
                        <Row>
                            <Col md={12} className="control">
                                <FormInput 
                                    label={
                                        <>
                                            <span className="required">* </span>Purpose
                                        </>
                                    }
                                    name="purposeDesc"
                                    type="text"
                                    value={adtrExpenditure.purposeDesc}
                                    onChange={(e) => handleChange(e)}
                                    validations={["required"]}
                                />
                                {formErrors['purposeDesc'] && <span className="error">{formErrors['purposeDesc']}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className="control">
                                <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Spent Amount"
                                    name="spentAmt"
                                    type="text"
                                    onChange={(e) => handleChange(e)}
                                    value={adtrExpenditure.spentAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['spentAmt'] && <span className="error">{formErrors['spentAmt']}</span>}

                            </Col>
                        </Row>
                    </div>
                    <div className="btn-div">
                        <div className="fright">
                            <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                            <button className="custom-button" type="button" onClick={(e) => handleSubmit(e)}>Update ADTR Expenditure</button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default EditAdtrExpenditure
